import { type GoldRushClientSettings } from "../types/Generic.types";

export async function debugOutput(
  settings: GoldRushClientSettings,
  ...content: unknown[]
) {
  if (settings.debug) {
    content.forEach((c) => {
      console.info("[DEBUG] |", c);
    });
  }
}
